
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipOffshore as ObiShipOffshoreElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-offshore.js';
 
 
 

 
 export const ObiShipOffshore = createComponent({
   react: React,
   tagName: 'obi-ship-offshore',
   elementClass: ObiShipOffshoreElement,
   events: {
     
   }
  });
 
 